import React from 'react';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import {
  LBL_RESTRICTED_SUB,
  LBL_RESTRICTED_TITLE_TABLE,
  LBL_RESTRICTED_TITLE_TOURNAMENT
} from 'types/colluder';

import styles from './GameTile.module.scss';

interface RestrictedOverlayProps {
  // Picks the title: 'cash' → "TABLE RESTRICTED", 'tournament' → "TOURNAMENT
  // RESTRICTED" (SnG + MTT). Defaults to the cash table wording.
  scope?: 'cash' | 'tournament';
}

// EN-10064 — full-tile restriction treatment shared by cash, SnG and MTT tiles:
// dim the card and center a lock with the neutral integrity copy. Advisory/
// decorative only — `pointer-events` stay off so the tile itself remains the tap
// target (the tap is blocked into the integrity modal upstream). No-disclosure
// (BR-3): the copy names no one and gives no reason.
const RestrictedOverlay: React.FC<RestrictedOverlayProps> = ({ scope = 'cash' }) => {
  const title =
    scope === 'tournament' ? LBL_RESTRICTED_TITLE_TOURNAMENT : LBL_RESTRICTED_TITLE_TABLE;
  return (
    <span className={styles.restrictedOverlay} aria-label={`${title} — ${LBL_RESTRICTED_SUB}`}>
      <LockOutlinedIcon className={styles.restrictedOverlayLock} aria-hidden />
      <span className={styles.restrictedOverlayTitle}>{title}</span>
      <span className={styles.restrictedOverlaySub}>{LBL_RESTRICTED_SUB}</span>
    </span>
  );
};

export default RestrictedOverlay;
